module.exports = __webpack_public_path__ + "img/guinea.55f0d09f.svg";